<template>
  <div class="alias-management-container">
    <div class="content">
      <div class="operation">
        <el-input class="search-input" v-model="keywords" placeholder="请输入关键字"></el-input>
        <el-button @click="getList">查询</el-button>
      </div>
      <div class="table">
        <el-table :data="tableData" v-loading="loading" height="100%" width="100%" header-row-class-name="header-class">
          <el-table-column v-for="col in cols" :key="col.prop" :prop="col.prop" :label="col.label" align="center" show-overflow-tooltip :formatter="formatter"></el-table-column>
          <el-table-column label="操作" align="center" width="150px">
            <template slot-scope="scope">
              <el-button type="text" @click.stop="editAlias(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @size-change="val => pagination.pageSize = val"
          @current-change="val => pagination.currentPage = val"
          :current-page="pagination.currentPage"
          :page-sizes="pagination.pageSizes"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogVisable" width="600px" center :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="control-list" v-loading="dialogLoading">
        <el-form :inline="true" @submit.native.prevent label-width="65px">
          <div class="item" v-for="item in controls" :key="item.id">
            <el-form-item label="控件名">
              <el-input readonly :value="item.name"></el-input>
            </el-form-item>
            <el-form-item label="别名">
              <el-input v-model="item.dbAlias"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisable = false">取 消</el-button>
        <el-button type="primary" @click="saveAlias">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'alias-management',
  data () {
    return {
      cols: [
        {prop: 'name', label: '名称'},
        {prop: 'type', label: '类型'},
        {prop: 'creator', label: '创建人'},
        {prop: 'createTime', label: '创建时间'},
        {prop: 'lastModifiedBy', label: '更新人'},
        {prop: 'lastModifiedDate', label: '更新时间'}
      ],
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      tableData: [],
      loading: false,
      keywords: '',
      dialogVisable: false,
      controls: [],
      dialogLoading: true,
      dataSource: [],
      id: ''
    }
  },
  methods: {
    getList () {
      this.loading = true
      this.pagination.currentPage = 1
      this.$nextTick(() => {
        let params = {name: this.keywords}
        this.$axios.get('/form-api/componentAlias/getFormAndProcessDefines', {params}).then(res => {
          this.dataSource = res.data || []
          if (res.data.length > 0) {
            this.tableData = res.data.slice((this.pagination.currentPage - 1) * this.pagination.pageSize, this.pagination.currentPage * this.pagination.pageSize)
          }
          this.pagination.total = res.data.length
          this.loading = false
        })
      })
    },
    editAlias (row) {
      this.dialogVisable = true
      this.getControls(row)
    },
    saveAlias () {
      let params = {}
      this.controls.forEach(e => { params[e.id] = e.dbAlias })
      this.$axios.post(`/form-api/componentAlias/updateComponentAlias/${this.id}`, params).then(res => {
        this.$message({
          message: '保存成功！',
          type: 'success'
        })
        this.dialogVisable = false
      })
    },
    async getControls (row) {
      this.dialogLoading = true
      await this.$axios.get(`/form-api/componentAlias/getFormOrProcessComponents/${row.type}/${row.id}`).then(res => {
        let list = res.data || []
        list.length > 0 && list.forEach(e => {
          this.controls.push({id: e.id, name: e.name, dbAlias: e.dbAlias})
          this.id = row.id
        })
      })
      this.dialogLoading = false
    },
    formatter (row, column, cellValue) {
      if (column.property === 'type') {
        if (row.type === 'process') {
          return '流程'
        } else if (row.type === 'form') {
          return '表单'
        }
      }
      return row[column.property]
    }
  },
  watch: {
    'pagination.currentPage' (val) {
      this.loading = true
      setTimeout(() => {
        this.tableData = this.dataSource.slice((val - 1) * this.pagination.pageSize, val * this.pagination.pageSize)
        this.loading = false
      }, 1000)
    },
    'pagination.pageSize' (val) {
      this.loading = true
      setTimeout(() => {
        this.tableData = this.dataSource.slice((this.pagination.currentPage - 1) * val, this.pagination.currentPage * val)
        this.loading = false
      }, 1000)
    },
    dialogVisable (val) {
      if (!val) {
        this.controls = []
        this.id = ''
      }
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style lang="scss">
.alias-management-container {
  height: 100%;
  & > .content {
    padding-top: 12px;
    background-color: #fff;
    height: 100%;
    .header-class {
      th {
        background-color: rgb(248, 248, 248);
        .cell {
          color: #706c6a;
          font-weight: 400;
          font-size: 12px;
        }
      }
    }
    .operation {
      padding: 0 0 20px 20px;
      .search-input {
        width: 248px;
        height: 24px;
        line-height: 24px;
        .el-input__inner {
          height: 24px;
          background: #fefefe;
          border: 1px solid #c2c3c4;
          border-radius: 4px;
        }
      }
      .el-button {
        width: 40px;
        height: 24px;
        border: 1px solid #55ACF1;
        color: #55ACF1;
        padding: 0;
        border-radius: 4px;
        margin-left: 18px
      }
    }
    .table {
      height: calc(100% - 110px);
    }
    .pagination {
      text-align: right;
      padding-top: 15px;
    }
  }
  .control-list {
    height: 450px;
    overflow: auto;
    text-align: center;
  }
  .el-dialog__footer, .el-dialog__body {
    padding: 15px;
  }
  .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/data/alias-management.vue